export default __webpack_public_path__ + "static/26-b2f6ad235be8e4532e944374b1ab2e4c.png";